import { typeahead } from "@mirage/service-typeahead-search/service/types";
import { isTaggedPeopleResult } from "@mirage/shared/search/people-recommendations";

export function serverScore(result: typeahead.TaggedResult): number {
  if (!isTaggedPeopleResult(result)) {
    return 0;
  }
  return result.result.score || 0;
}
